export function notification(notifyType, message, description) {
    $(document).on('click', '.js-close-notification', function () {
        $('.notification').slideUp('slow', function () {
            $(this).remove()
        })
    })
    function showNotification() {
        setTimeout(function () {
            $('.notification').slideDown('slow')
        }, 1000)
    }

    function hideNotification() {
        setTimeout(function () {
            $('.notification').slideUp('slow')
        }, 5000)
        setTimeout(function () {
            $('.notification').remove()
        }, 6000)
    }
    function errorColor() {
        if (notifyType === 'error') return 'text-danger'
        else return 'text-success'
    }

    if (!description) {
        description = `Thank you for using Hedlyner`
    }

    $('body').prepend(`
        <div class="notification ${notifyType}" style="background:#262626">
            <div class="w-100 position-relative">
                <button type="button" class="btn-without-style notification-close js-close-notification" aria-label="Close">
                    <img class="img-fluid" src="/images/close-event-modal.svg" alt="close">
                </button>
            </div>
            <div class="notification-header">
                <h3 class="notification-title ${errorColor()}">${message}</h3>
            </div>
            <div class="delimiter"></div>
            <div class="notification-body">
                <p class="notification-text main-text" style="color:#acacac">${description}</p>
            </div>
        </div>
    `)

    showNotification()
    hideNotification()
}
